<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title" v-if="isFreeMember">
        <v-alert prominent color="#FFFAE8">
          <v-row align="center">
            <v-col class="grow">
              Your membership plan includes access to
              {{ membership && membership.membershipData.satellite_report }}-set
              of satellite reports monthly, this set includes our
              {{ membership && membership.membershipData.pasture_report }} basic
              reports. Please upgrade your membership to increase the frequency
              or number of reports to which you have access.
            </v-col>
            <v-col class="shrink">
              <v-btn
                color="primary"
                dark
                :to="{ name: 'profile', params: { paymentTab: true } }"
                >Upgrade membership type</v-btn
              >
            </v-col>
          </v-row>
        </v-alert>
      </div>
      <div>
        <v-card>
          <v-tabs class="mt-4 mb-5" v-model="mainTab">
            <v-tab>
              {{ this.$t("reports.myRecentReports") }}
            </v-tab>
            <v-tab> {{ this.$t("reports.allReports") }} </v-tab>
          </v-tabs>
        </v-card>
        <v-tabs-items v-model="mainTab">
          <v-tab-item>
            <div class="page-title">
              <h2 class="mb-4 pa-4">{{this.$t("reports.myRecentReports"),}}</h2>
              <v-btn
                :disabled="!primaryFarm || locations.length < 1"
                color="primary"
                @click="requestSatelliteReport()"
              >
                {{ this.$t("reports.requestSatelliteReport") }}
              </v-btn>
            </div>
            <v-card elevation="10" class="">
              <v-card-text>
                <div class="d-flex mt-5">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    height="5px"
                    placeholder="Search"
                    dense
                    v-model="todaySearch"
                    class="shrink"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    height="40"
                    width="40"
                    max-width="40"
                    outlined
                    class="ml-8"
                    @click="refreshTable"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <div class="py-1 title">
                    {{ todayfrom }} - {{ todayto }} {{ $t('of') }} {{ todaytotalPastures }}
                  </div>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="todayTableOptions.page <= 1"
                    @click="todaypageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="todayTableOptions.page >= todaytotalPages"
                    @click="todaypageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn>
                  <!-- <v-btn class="mx-2" fab small outlined color="primary">
                          <v-icon dark>
                            mdi-cog-outline
                          </v-icon>
                        </v-btn> -->

                  <v-menu
                    v-model="customizeMenu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>

                    <v-card width="417">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t("customization")
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t("recordsPerPage") }}
                        </div>
                        <v-list-item>
                          <v-list-item-content>
                            <v-slider
                              v-model="itemsPerPageSlider"
                              :tick-labels="itemsPerPageOptions"
                              :max="3"
                              step="1"
                              ticks="always"
                              tick-size="4"
                            ></v-slider>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in reportHeaders"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-model="selectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                                :disabled="
                                  header.text == 'ID' || header.text == 'Tag'
                                "
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>

                          <v-btn
                            outlined
                            color="primary"
                            @click="resetDefaut"
                            width="190"
                          >
                            {{ $t("restoreDefault") }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            @click="resetTableStructure"
                            width="190"
                          >
                            {{ $t("apply") }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>

                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="exportToPDF('document')"
                    :disabled="!pastureMgmtAllToday.rows?.length"
                  >
                    <!-- <v-img src="/icons/download.svg"></v-img> -->
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="printPDF('document')"
                    :disabled="!pastureMgmtAllToday.rows?.length"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </div>
                <div ref="document">
                  <v-data-table
                    :headers="tableHeaders"
                    :items="pastureMgmtAllToday.rows"
                    item-key="id"
                    :items-per-page="10"
                    :hide-default-footer="true"
                    :options.sync="tableOptions"
                    :server-items-length="pastureMgmtAllToday.totalCount"
                    show-select
                  >
                    <template v-slot:top> </template>
                    <template v-slot:item.createdAt="{ item }">
                      {{ formatDate(item.createdAt) }}
                    </template>
                    <template v-slot:item.dateOfInterest="{ item }">
                      {{ formatDate(item.dateOfInterest) }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        v-if="item.status == 'COMPLETED'"
                        class="ma-2"
                        color="green"
                        outlined
                      >
                        {{ item.status }}
                      </v-chip>
                      <v-chip v-else class="ma-2" color="red" outlined>
                        {{ item.status }}
                      </v-chip>
                    </template>
                    <!-- eslint-disable -->
                    <template v-slot:item.view="{ item }">
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="item.reportS3Key ? null : on"
                          >
                            <v-icon
                              :disabled="!item.reportS3Key"
                              color="green"
                              @click="openPdfDialog(item)"
                            >
                              mdi-eye
                            </v-icon>
                          </div>
                        </template>
                        {{ etaGenerator(item.createdAt) }}
                      </v-tooltip>
                    </template>
                    <template v-slot:item.download="{ item }">
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="item.reportS3Key ? null : on"
                          >
                            <v-btn
                              :disabled="!item.reportS3Key"
                              class="mx-2"
                              fab
                              small
                              outlined
                              @click="downloadPdf(item)"
                            >
                              <a :href="item.reportS3Key" download>
                                <v-img
                                  v-show="item.reportS3Key"
                                  src="/icons/download.svg"
                                ></v-img>
                                <v-img
                                  v-show="!item.reportS3Key"
                                  src="/icons/download_disabled.svg"
                                ></v-img>
                              </a>
                            </v-btn>
                          </div>
                        </template>
                        {{ etaGenerator(item.createdAt) }}
                      </v-tooltip>
                      <!-- <v-img src="/icons/download.svg" @click="downloadPdf(item)"></v-img> -->
                      <!-- <v-icon color="green" > mdi-download </v-icon> -->
                    </template>
                  </v-data-table>
                </div>
                <v-card
                  v-if="locations && (!primaryFarm || locations?.length < 1)"
                  flat
                  color="transparent"
                  class="px-10 mt-5"
                >
                  <div class="text-center white" style="min-height: 70vh">
                    <v-row justify="center" align="center">
                      <v-col cols="12" sm="4">
                        <div class="py-15">
                          <img src="/img/Notes.svg" /><br />
                          <!-- <strong>No Farm Found</strong><br /> -->
                          <div class="pb-4">
                            <p class="red--text">
                              Geofence details are required to generate
                              satellite report.
                            </p>

                            <small class="red--text">
                              click the button below to add/update farm
                              details.</small
                            >
                          </div>
                          <v-btn
                            depressed
                            color="primary"
                            dark
                            @click="$router.push({ name: 'My farm' })"
                          >
                            {{ $t("Go to My Farm") }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
                <div
                  class="text-center"
                  v-else-if="pastureMgmtAllToday.rows.length === 0"
                >
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <div class="py-16">
                        <img src="/img/Notes.svg" /><br />
                        <strong>{{ $t('noRecordFound') }}</strong><br />
                        <div class="py-4">
                          <small
                            >No satellite reports have been requested. Kindly
                            request some satellite reports to get them listed
                            here.</small
                          >
                        </div>
                        <v-btn
                          :disabled="!primaryFarm || locations.length < 1"
                          color="primary"
                          @click="requestSatelliteReport()"
                        >
                          {{ this.$t("reports.requestSatelliteReport") }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <div class="page-title">
              <h2 class="mb-4">{{this.$t("reports.allReports"),}}</h2>
              <v-btn
                :disabled="!primaryFarm || locations.length < 1"
                color="primary"
                @click="requestSatelliteReport()"
              >
                {{ this.$t("reports.requestSatelliteReport") }}
              </v-btn>
            </div>
            <v-card elevation="10" class="">
              <v-card-text>
                <div class="d-flex mt-5">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    height="5px"
                    placeholder="Search"
                    dense
                    v-model="search"
                    class="shrink"
                  ></v-text-field>
                  <v-btn
                    :disabled="!primaryFarm || locations?.length < 1"
                    color="primary"
                    height="40"
                    width="40"
                    max-width="40"
                    outlined
                    class="ml-8"
                    @click="refreshTable"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <div class="py-1 title">
                    {{ from }} - {{ to }} {{ $t('of') }} {{ totalPastures }}
                  </div>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="tableOptions.page <= 1"
                    @click="pageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="tableOptions.page >= totalPages"
                    @click="pageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn>
                  <!-- <v-btn class="mx-2" fab small outlined color="primary">
                          <v-icon dark>
                            mdi-cog-outline
                          </v-icon>
                        </v-btn> -->

                  <v-menu
                    v-model="customizeMenuAll"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>

                    <v-card width="417">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t("customization")
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t("recordsPerPage") }}
                        </div>
                        <v-list-item>
                          <v-list-item-content>
                            <v-slider
                              v-model="itemsPerPageSlider"
                              :tick-labels="itemsPerPageOptions"
                              :max="3"
                              step="1"
                              ticks="always"
                              tick-size="4"
                            ></v-slider>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in reportHeaders"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-model="selectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                                :disabled="
                                  header.text == 'ID' || header.text == 'Tag'
                                "
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>

                          <v-btn
                            outlined
                            color="primary"
                            @click="resetDefaut"
                            width="190"
                          >
                            {{ $t("restoreDefault") }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            @click="resetTableStructure"
                            width="190"
                          >
                            {{ $t("apply") }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>

                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="exportToPDF('documentAll')"
                    :disabled="!pastureMgmtAll.rows?.length"
                  >
                    <!-- <v-img src="/icons/download.svg"></v-img> -->
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="printPDF('documentAll')"
                    :disabled="!pastureMgmtAll.rows?.length"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </div>
                <div ref="documentAll" class="mt-5">
                  <v-data-table
                    :headers="tableHeaders"
                    :items="pastureMgmtAll.rows"
                    item-key="id"
                    :items-per-page="10"
                    :loading="loading"
                    :hide-default-footer="true"
                    :options.sync="tableOptions"
                    :server-items-length="pastureMgmtAll.totalCount"
                    show-select
                  >
                    <template v-slot:top> </template>
                    <template v-slot:item.createdAt="{ item }">
                      {{ formatDate(item.createdAt) }}
                    </template>
                    <template v-slot:item.dateOfInterest="{ item }">
                      {{ formatDate(item.dateOfInterest) }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        v-if="item.status == 'COMPLETED'"
                        class="ma-2"
                        color="green"
                        outlined
                      >
                        {{ item.status }}
                      </v-chip>
                      <v-chip v-else class="ma-2" color="red" outlined>
                        {{ item.status }}
                      </v-chip>
                    </template>
                    <!-- eslint-disable -->
                    <template v-slot:item.view="{ item }">
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="item.reportS3Key ? null : on"
                          >
                            <v-icon
                              :disabled="!item.reportS3Key"
                              color="green"
                              @click="openPdfDialog(item)"
                            >
                              mdi-eye
                            </v-icon>
                          </div>
                        </template>
                        {{ etaGenerator(item.createdAt) }}
                      </v-tooltip>
                    </template>
                    <template v-slot:item.download="{ item }">
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="item.reportS3Key ? null : on"
                          >
                            <v-btn
                              :disabled="!item.reportS3Key"
                              class="mx-2"
                              fab
                              small
                              outlined
                              @click="downloadPdf(item)"
                            >
                              <a :href="item.reportS3Key" download>
                                <v-img
                                  v-show="item.reportS3Key"
                                  src="/icons/download.svg"
                                ></v-img>
                                <v-img
                                  v-show="!item.reportS3Key"
                                  src="/icons/download_disabled.svg"
                                ></v-img>
                              </a>
                            </v-btn>
                          </div>
                        </template>
                        {{ etaGenerator(item.createdAt) }}
                      </v-tooltip>

                      <!-- <v-img src="/icons/download.svg" @click="downloadPdf(item)"></v-img> -->
                      <!-- <v-icon color="green" > mdi-download </v-icon> -->
                    </template>
                  </v-data-table>
                </div>
                <v-card
                  v-if="!primaryFarm || locations?.length < 1"
                  flat
                  color="transparent"
                  class="px-10 mt-5"
                >
                  <div class="text-center white" style="min-height: 70vh">
                    <v-row justify="center" align="center">
                      <v-col cols="12" sm="4">
                        <div class="py-15">
                          <img src="/img/Notes.svg" /><br />
                          <!-- <strong>No Farm Found</strong><br /> -->
                          <div class="pb-4">
                            <p class="red--text">
                              Geofence details are required to generate
                              satellite report.
                            </p>

                            <small class="red--text">
                              click the button below to add/update farm
                              details.</small
                            >
                          </div>
                          <v-btn
                            depressed
                            color="primary"
                            dark
                            @click="$router.push({ name: 'My farm' })"
                          >
                            {{ $t("Go to My Farm") }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
                <div
                  class="text-center"
                  v-else-if="pastureMgmtAll.rows.length === 0"
                >
                  <v-row justify="center" align="center">
                    <v-col cols="12" sm="4">
                      <div class="py-16">
                        <img src="/img/Notes.svg" /><br />
                        <strong>{{ $t('noRecordFound') }}</strong><br />
                        <div class="py-4">
                          <small
                            >No satellite reports have been requested. Kindly
                            request some satellite reports to get them listed
                            here.</small
                          >
                        </div>
                        <v-btn
                          :disabled="!primaryFarm || locations.length < 1"
                          color="primary"
                          @click="requestSatelliteReport()"
                        >
                          {{ this.$t("reports.requestSatelliteReport") }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>
    <confirmation-dialog
      v-if="confirmationDialog"
      :dialogI="confirmationDialog"
      @closeDialog="closeDialog = false"
    ></confirmation-dialog>
    <v-dialog
      v-model="showRequestSatelliteReportDialog"
      width="800"
      @click:outside="showRequestSatelliteReportDialog = false"
      :retain-focus="false"
    >
      <v-card class="custom-card" rounded="0">
        <v-toolbar color="secondary" class="white--text" flat>
          <v-toolbar-title class="font-weight-bold">
            {{ this.$t("reports.requestSatelliteReport") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="white--text"
            @click="showRequestSatelliteReportDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="black--text">
          <!-- Request new satellite report -->
          <v-form
            @submit.prevent="submitReport"
            ref="reportForm"
            v-model="reportFormValid"
            lazy-validation
          >
            <v-row class="mt-4">
              <v-col cols="6">
                <label>
                  {{ this.$t("reports.locationInfo") }}<sup>*</sup></label
                >

                <v-text-field
                  class="input_pointer_cursor"
                  :rules="locationInfoRules"
                  required
                  :error-messages="errors.locationInfo"
                  @mousedown="
                    () => {
                      (showRequestSatelliteReportDialog = false),
                        (existingLocationDialog = true);
                    }
                  "
                  v-model="locationInfoModel"
                  placeholder="Select Location"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="hasMembership">
                <label>Date of Interest<sup>*</sup></label>
                <v-dialog
                  ref="dialog"
                  v-model="dateModal"
                  :return-value.sync="dateOfInterest"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="dateRules"
                      v-model="dateOfInterest"
                      prepend-icon="mdi-calendar"
                      dense
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateOfInterest"
                    scrollable
                    :max="new Date().toISOString().substr(0, 10)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateModal = false">
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(dateOfInterest)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-card-actions class="mt-10" style="padding-right: 0">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
                @click="
                  showRequestSatelliteReportDialog = false;
                  locationInfoModel = null;
                "
              >
                Cancel
              </v-btn>
              <v-btn
                type="submit"
                right
                height="44"
                color="primary"
                class="px-5"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
          <!-- Request new satellite report end -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="existingLocationDialog"
      width="800"
      @click:outside="existingLocationDialog = false"
      :retain-focus="false"
    >
      <v-card class="custom-card" rounded="10">
        <v-toolbar color="secondary" class="white--text" flat>
          <v-toolbar-title class="font-weight-bold">
            {{ this.$t("reports.existingLocation") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="white--text"
            @click="existingLocationDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="black--text">
          <v-tabs class="mt-4 mb-5" v-model="existingLocationTabs">
            <v-tab> {{ this.$t("farms") }} </v-tab>
            <v-tab>{{ this.$t("farm.zones") }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="existingLocationTabs">
            <v-tab-item class="border">
              <v-list>
                <v-list-item style="background: #ffb443">
                  <v-row>
                    <v-col cols="6"
                      ><v-list-item-content>
                        <v-list-item-title>{{
                          this.$t("reports.farmLocation")
                        }}</v-list-item-title>
                      </v-list-item-content></v-col
                    >
                    <v-col cols="6"
                      ><v-list-item-content class="text-right">
                        <v-list-item-title>{{
                          this.$t("reports.location")
                        }}</v-list-item-title>
                      </v-list-item-content></v-col
                    >
                  </v-row>
                </v-list-item>
                <!-- <span v-for="(fCoord, index) in getAllFarmCoordinates" :key="index" > -->
                <v-list-item v-for="location in locations">
                  <v-row>
                    <v-col cols="10"
                      ><v-list-item-content
                        style="cursor: pointer"
                        @click="selectCoordinates(location)"
                      >
                        <v-list-item-title
                          ><img src="/img/sugarcane-farm.png" class="mr-2" />
                          {{ location && location.address }}</v-list-item-title
                        >
                      </v-list-item-content></v-col
                    >
                    <v-col cols="2"
                      ><v-list-item-content class="text-right">
                        <v-list-item-title
                          @click="geoFenceMapView(location)"
                          class="farms"
                        >
                          <a>Map view</a>
                        </v-list-item-title>
                      </v-list-item-content></v-col
                    >
                  </v-row>
                </v-list-item>
                <!-- <v-divider ></v-divider>
                   </span> -->
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list>
                <v-list-item style="background: #ffb443">
                  <v-row>
                    <v-col cols="6"
                      ><v-list-item-content>
                        <v-list-item-title>ZONE NAME</v-list-item-title>
                      </v-list-item-content></v-col
                    >
                    <v-col cols="6"
                      ><v-list-item-content class="text-right">
                        <v-list-item-title>Location</v-list-item-title>
                      </v-list-item-content></v-col
                    >
                  </v-row>
                </v-list-item>
                <span
                  v-for="(fCoord, index) in getAllZoneCoordinates"
                  :key="index"
                >
                  <v-list-item>
                    <v-row>
                      <v-col cols="10"
                        ><v-list-item-content
                          style="cursor: pointer"
                          @click="selectCoordinates(fCoord)"
                        >
                          <v-list-item-title
                            ><img src="/img/onions-farm.png" class="mr-2" />
                            {{ fCoord.geofenceName }}</v-list-item-title
                          >
                        </v-list-item-content></v-col
                      >
                      <v-col cols="2"
                        ><v-list-item-content class="text-right">
                          <v-list-item-title
                            @click="geoFenceMapView(fCoord)"
                            class="farms"
                            ><a>Map view</a></v-list-item-title
                          >
                        </v-list-item-content></v-col
                      >
                    </v-row>
                  </v-list-item>
                  <v-divider></v-divider>
                </span>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="optionDialog"
      width="800"
      @click:outside="optionDialog = false"
      :retain-focus="false"
    >
      <v-card class="custom-card" rounded="0">
        <!-- <v-card-actions class="mt-10" style="padding-right: 0"> -->
        <v-toolbar color="secondary" class="white--text" flat>
          <v-toolbar-title class="font-weight-bold">
            {{ this.$t("reports.requestSatelliteReport") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="white--text" @click="optionDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-card-text class="black--text pt-3">
          <span>
            <center>{{ $t('locationMsg') }}</center>
          </span>
          <v-spacer></v-spacer>
          <div class="text-center pt-4">
            <v-btn
              outlined
              class="mr-2"
              height="44"
              depressed
              color="primary"
              @click="openExistingDialog"
            >
              Use Existing Location
            </v-btn>
            <v-btn @click="showGeofence" height="44" color="primary">
              {{ $t('outlineInNewLocation') }}
            </v-btn>
          </div>
          <!-- </v-card-actions> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showGeofenceNameModal"
      width="800"
      @click:outside="optionDialog = false"
      :retain-focus="false"
      persistent
    >
      <v-card class="custom-card" flat>
        <v-form
          @submit.prevent="submitGeofenceName"
          ref="geofenceNameForm"
          v-model="geofenceNameValid"
          lazy-validation
        >
          <v-toolbar flat color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              {{ $t('goefenceName') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="white--text"
              @click="showGeofenceNameModal = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="black--text">
            <!-- <v-card-actions class="mt-10" style="padding-right: 0"> -->
            <v-spacer></v-spacer>
            <div class="text-center pt-4">
              <v-text-field
                outlined
                :rules="geofenceNameRules"
                required
                :error-messages="errors.geofenceNameError"
                height="5px"
                placeholder="Geofence Name"
                dense
                v-model="newGeofenceName"
                class="shrink"
              >
              </v-text-field>
            </div>
            <!-- </v-card-actions> -->
            <v-card-actions style="padding-right: 0">
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                right
                height="44"
                color="primary"
                class="px-5"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="pdfDialogDialog"
      width="1200"
      @click:outside="pdfDialogDialog = false"
      :retain-focus="false"
    >
      <v-card
        style="overflow: hidden"
        height="1200"
        width="1200"
        class="custom-card"
        rounded="0"
      >
        <v-toolbar color="secondary" class="white--text">
          <v-toolbar-title class="font-weight-bold"> Report </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="white--text" @click="pdfDialogDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="black--text">
          <!-- <vue-pdf-embed :source="'https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK'" /> -->
          <!-- <vue-pdf-embed :source="currentPdfLink" /> -->
          <iframe
            :src="currentPdfLink"
            height="1000"
            width="1200"
            frameborder="no"
            style="width: 100%"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <primary-geofence
      v-if="showMap"
      :showMap="showMap"
      :farm="currentFarmLocation"
      @close-location-modal="locationMapClosed"
      @close-without-change="closeWithoutChange"
    ></primary-geofence>

    <GeoFenceView
      v-if="showGeofenceOnMap"
      :dialogU="showGeofenceOnMap"
      :polygonCoords="currentGeofenceLatLng"
      :lat="currentGeofenceLat"
      :lng="currentGeofenceLng"
      @dialog-closed="geoFenceMapViewClosed"
    />
  </div>
</template>

<script>
// import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
// import FarmService from "@/_services/farmService";
import { getFarmLocations } from "@/graphql/Farm.gql";
import FarmService from "@/_services/farmService";
import ProfileService from "../../_services/ProfileService";
import ConfirmationDialog from "./ConfirmationDialog.vue";
import { getAllZoneCoordinates } from "@/graphql/Satellite.gql";
// import { getPrimaryFarm } from '@/graphql/Farm.gql'
import * as moment from "moment";
import "moment-timezone";
import gql from "graphql-tag";
import loading from "@/mixins/LoadingMixin";
import PrimaryGeofence from "../my_farm/PrimaryGeofence.vue";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import GeoFenceView from "@/components/GeoFenceView.vue";
import { mapGetters } from "vuex";
// import axios from 'axios'

export default {
  apollo: {
    locations: {
      query: getFarmLocations,
      fetchPolicy: "network-only",
      variables() {
        return {
          farmId: this.primaryFarm?.id && Number(this.primaryFarm.id),
        };
      },
      update: data => data.farmLocations,
      skip: () => true,
    },
    membership: {
      query: gql`
        query getCurrentMembershipOfCurrentUserFromHeader {
          getCurrentMembershipOfCurrentUserFromHeader {
            id
            membership_id
            payment_id
            start_date
            end_date
            active
            membershipData {
              membership_name
              satellite_report
              pasture_report
              membershipFeesData {
                is_free_trial
              }
            }
          }
        }
      `,
      update: data => data.getCurrentMembershipOfCurrentUserFromHeader,
      result({ data }) {
        console.log();
        if (
          data.getCurrentMembershipOfCurrentUserFromHeader &&
          data.getCurrentMembershipOfCurrentUserFromHeader.membershipData
        ) {
          this.isFreeMember =
            data.getCurrentMembershipOfCurrentUserFromHeader?.membershipData?.membershipFeesData?.is_free_trial;
          this.hasMembership = true;
        } else {
          this.hasMembership = false;
        }
        // console.log('isFreeMember', this.isFreeMember)
      },
    },
    // getAllFarmCoordinates: {
    //   query: getAllFarmCoordinates,
    //   variables() {
    //     return {
    //     }
    //   },
    //   result({data}) {
    //     this.loading = false;
    //     let tmpObj = JSON.parse(JSON.stringify(data.getAllFarmCoordinates[0]))
    //     tmpObj.coordinates = tmpObj.FarmCoordinates
    //     this.orgFarm = tmpObj
    //     console.log(data, 'farm coo')
    //   },
    //   fetchPolicy: 'network-only',
    //   update: data => data.getAllFarmCoordinates,
    // skip: () => true,
    // },
    getAllZoneCoordinates: {
      query: getAllZoneCoordinates,
      variables() {
        return {};
      },
      result() {
        this.loading = false;
      },
      fetchPolicy: "network-only",
      update: data => data.getAllZoneCoordinates,
      // skip: () => true,
    },
    pastureMgmtAll: {
      query() {
        return gql`
          query pastureMgmtAll(
            $page: Int
            $limit: Int
            $search: String
            $orderField: String
            $order: String
          ) {
            pastureMgmtAll(
              page: $page
              limit: $limit
              search: $search
              orderField: $orderField
              order: $order
            ) {
              rows {
                id
                dateOfInterest
                reportType
                dateOfInterest
                zoomLevel
                userId
                centerLatitude
                centerLongitude
                satelliteSource
                inputImage
                geoImagePath
                shortImagePath
                reportPDFPath
                inputImgS3Key
                status
                createdAt
                locationName
                reportS3Key
                reportName
                inputImage
              }
              count
              totalCount
            }
          }
        `;
      },
      variables() {
        return {
          page: this.tableOptions.page,
          limit: this.tableOptions.itemsPerPage,
          search: this.search,
          orderField: this.todayOrderby,
          order: this.todayOrderType,
        };
      },
      fetchPolicy: "network-only",
      update: data => data.pastureMgmtAll,
      result({ data }) {
        // console.log(data)
        this.totalPastures = data.pastureMgmtAll.totalCount;
        this.totalPages = Math.ceil(
          this.totalPastures / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          (this.tableOptions.itemsPerPage - data.pastureMgmtAll.count);
        console.log(this.to, "to");
        this.loaded = true;
      },
    },
    pastureMgmtAllToday: {
      query() {
        return gql`
          query pastureMgmtAllToday(
            $page: Int
            $limit: Int
            $search: String
            $orderField: String
            $order: String
          ) {
            pastureMgmtAllToday(
              page: $page
              limit: $limit
              search: $search
              orderField: $orderField
              order: $order
            ) {
              rows {
                id
                dateOfInterest
                reportType
                dateOfInterest
                zoomLevel
                userId
                centerLatitude
                centerLongitude
                satelliteSource
                inputImage
                geoImagePath
                shortImagePath
                reportPDFPath
                inputImgS3Key
                status
                createdAt
                locationName
                reportS3Key
                reportName
                inputImage
              }
              count
              totalCount
            }
          }
        `;
      },
      variables() {
        return {
          page: this.todayTableOptions.page,
          limit: this.todayTableOptions.itemsPerPage,
          search: this.todaySearch,
          orderField: this.todayOrderby,
          order: this.todayOrderType,
        };
      },
      fetchPolicy: "network-only",
      update: data => data.pastureMgmtAllToday,
      result({ data }) {
        // console.log(data)
        this.todaytotalPastures = data.pastureMgmtAllToday.totalCount;
        this.todaytotalPages = Math.ceil(
          this.todaytotalPastures / this.todayTableOptions.itemsPerPage
        );
        this.todayfrom =
          (this.todayTableOptions.page - 1) *
            this.todayTableOptions.itemsPerPage +
          1;
        this.todayto =
          this.todayTableOptions.page * this.todayTableOptions.itemsPerPage -
          (this.todayTableOptions.itemsPerPage -
            data.pastureMgmtAllToday.count);
        console.log(this.to, "to");
        this.loaded = true;
      },
    },
  },
  computed: {
    ...mapGetters(["getfarm"]),
  },
  components: {
    "confirmation-dialog": ConfirmationDialog,
    PrimaryGeofence,
    GeoFenceView,
    // VuePdfEmbed
  },
  async mounted() {
    const { data } = await FarmService.getPrimaryFarm();

    this.primaryFarm = data;
    this.$apollo.queries.membership.refetch();

    this.$apollo.queries.locations.skip = false;
    this.$apollo.queries.locations.refetch();

    document.title = "Satellite Reports";
    this.tableHeaders = this.reportHeaders;
    this.selectedHeaders = this.allSelectedHeaders;
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 1000);
  },
  data() {
    return {
      primaryFarm: {},
      showGeofenceOnMap: false,
      currentGeofenceLatLng: [],
      currentGeofenceLat: 0,
      currentGeofenceLng: 0,
      isFreeMember: false,
      hasMembership: false,
      farm: {},
      customizeMenu: false,
      customizeMenuAll: false,
      itemsPerPageSlider: 3,
      selectedHeaders: [],
      oldSelected: [],
      tableHeaders: [],
      itemsPerPageOptions: [5, 10, 25, 50],
      tabletSelectHeaders: [],
      todayOrderby: "reportType",
      todayOrderType: "desc",
      loaded: false,
      geofenceNameValid: false,
      newGeofenceName: "",
      showGeofenceNameModal: false,
      newGeofence: false,
      orgFarm: {},
      showMap: false,
      todaySearch: "",
      totalPastures: 0,
      todaytotalPastures: 0,
      todaytotalPages: 0,
      pastureMgmtAll: { rows: [] },
      pastureMgmtAllToday: { rows: [] },
      allSelectedHeaders: [
        this.$t("reports.name"),
        this.$t("reports.dateOfInterest"),
        this.$t("reports.reportType"),
        this.$t("reports.requestDate"),
        this.$t("reports.status"),
        this.$t("reports.view"),
        this.$t("reports.download"),
      ],
      reportHeaders: [
        { text: this.$t("reports.name"), value: "locationName" },
        { text: this.$t("reports.dateOfInterest"), value: "dateOfInterest" },
        { text: this.$t("reports.reportType"), value: "reportType" },
        { text: this.$t("reports.requestDate"), value: "createdAt" },
        //    { text:this.$t("reports.locationInfo"),value:"locationInfo"},
        { text: this.$t("reports.status"), value: "status" },
        { text: this.$t("reports.view"), value: "view" },
        { text: this.$t("reports.download"), value: "download" },

        // { text:"zoomLevel" ,value:"zoomLevel"},
        // { text:"userId" ,value:"userId"},
        // { text:"centerLatitude" ,value:"centerLatitude"},
        // { text:"centerLongitude" ,value:"centerLongitude"},
        // { text:"satelliteSource" ,value:"satelliteSource"},
        // { text:"inputImage" ,value:"inputImage"},
        // { text:"geoImagePath" ,value:"geoImagePath"},
        // { text:"shortImagePath" ,value:"shortImagePath"},
        // { text:"reportPDFPath" ,value:"reportPDFPath"},
        // { text:"inputImgS3Key" ,value:"inputImgS3Key"},

        // { text:"__typename" ,value:"__typename"},
      ],
      tableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      todayTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      errors: {
        locationInfo: "",
        geofenceNameError: "",
      },
      locationInfoRules: [v => !!v || "Location Info is Required"],
      geofenceNameRules: [v => !!v || "Geofence name is Required"],
      dateRules: [
        v =>
          new Date(v).getDate() <= new Date().getDate() ||
          "Future date selected",
      ],
      reportFormValid: true,
      locationInfoModel: null,
      coordinatesModel: null,
      dateModal: false,
      dateOfInterest: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      loading: true,
      user: {
        name: "",
        role: "",
        userName: "",
      },
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("reports.reports"),
          disabled: true,
          to: "/satellite-reports",
        },
        {
          text: this.$t("reports.satelliteReports"),
          disabled: true,
          to: "/satellite-reports",
        },
      ],
      mainTab: null,
      existingLocationTabs: null,
      to: "",
      from: "",
      todayto: "",
      todayfrom: "",
      totalPages: "",
      transition: true,
      pageCount: 1,
      currentrows: 0,
      search: "",
      selected: [],
      items: [],
      totaldrugs: 1,
      selectedItem: false,
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      headers: [
        {
          text: this.$t("reports.name"),
          align: "start",
          sortable: false,
          class: "black--text",
          value: "name",
        },
        {
          text: this.$t("reports.dateOfInterest"),
          value: "dateOfInterest",
          class: "black--text",
        },
        {
          text: this.$t("reports.reportType"),
          value: "reportType",
          class: "black--text",
        },
        {
          text: this.$t("reports.requestDate"),
          value: "requestDate",
          class: "black--text",
        },
        {
          text: this.$t("reports.locationInfo"),
          value: "locationInfo",
          class: "black--text",
        },
        {
          text: this.$t("reports.status"),
          value: "status",
          class: "black--text",
          sortable: false,
        },
      ],
      showRequestSatelliteReportDialog: false,
      existingLocationDialog: false,
      confirmationDialog: false,
      optionDialog: false,
      pdfDialogDialog: false,
      currentPdfLink: "",
    };
  },
  watch: {
    mainTab(nV, oV) {
      console.log(nV, oV);
    },
    tableOptions: {
      handler(res) {
        console.log(res);
        if (res.sortBy.length && res.sortDesc.length) {
          (this.todayOrderby = res.sortBy[0]),
            (this.todayOrderType = res.sortDesc[0] ? "desc" : "asc");
          this.$apollo.queries.pastureMgmtAllToday.refetch();
          this.$apollo.queries.pastureMgmtAll.refetch();
        }
      },
    },
  },
  methods: {
    geoFenceMapView(geofence) {
      console.log("geofence", geofence);
      var codes = [];
      if (geofence?.address) {
        if (geofence.GeoFences && geofence.GeoFences.length > 0) {
          geofence.GeoFences[0].geofenceCoordinates.map(function (elm) {
            codes.push({
              lat: parseFloat(elm["lat"]),
              lng: parseFloat(elm["log"]),
            });
          });
        }
      } else {
        geofence.geofenceCoordinates.map(function (elm) {
          codes.push({
            lat: parseFloat(elm["lat"]),
            lng: parseFloat(elm["log"]),
          });
        });
      }

      this.currentGeofenceLatLng = codes;
      this.currentGeofenceLat = parseFloat(
        geofence.lat || geofence.geofenceCoordinates[0].lat
      );
      this.currentGeofenceLng = parseFloat(
        geofence.log || geofence.geofenceCoordinates[0].log
      );
      this.showGeofenceOnMap = true;
    },
    geoFenceMapViewClosed() {
      this.showGeofenceOnMap = false;
    },
    async refreshTable() {
      this.startLoading();
      await this.$apollo.queries.pastureMgmtAllToday.refetch();
      await this.$apollo.queries.pastureMgmtAll.refetch();
      this.stopLoading();
    },
    etaGenerator(createdAt) {
      let createdDate = new Date(createdAt);
      let twoHoursMS = 2 * 60 * 60 * 1000;
      console.log(new Date(createdDate.getTime() + twoHoursMS), "eta");
      let etaTime = new Date(createdDate.getTime() + twoHoursMS).toISOString();
      return `Report Completion ETA ${etaTime.split("T")[0]} ${
        etaTime.split("T")[1].split(".")[0]
      }`;
    },
    assignValues(farm) {
      // console.log('edited', farm)
      (this.farm.id = farm.id),
        (this.farm.farmName = farm.farmName),
        (this.farm.registrationNo = null),
        (this.farm.lat = farm.lat),
        (this.farm.log = farm.log),
        (this.farm.address = farm.address),
        (this.farm.area = farm.area),
        (this.farm.areaUomId = farm.areaUomId),
        (this.farm.parameter = farm.parameter),
        (this.farm.parameterUomId = 0),
        (this.farm.farmingGoals = []),
        (this.farm.farmOwnershipType = farm.farmOwnershipType),
        (this.farm.farmGeofence = []),
        (this.farm.farmType = farm.farmType),
        (this.farm.productionSystem =
          typeof JSON.parse(farm.productionSystem) === "object"
            ? JSON.parse(farm.productionSystem)
            : [JSON.parse(farm.productionSystem)]),
        (this.farm.farmOwner = farm.farmOwner),
        (this.farm.country = farm.country),
        (this.farm.state = farm.state),
        (this.farm.city = farm.city),
        (this.farm.govRegistrationNum = farm.govRegistrationNum),
        (this.farm.contractMating = farm.contractMating),
        (this.farm.cooperativeId = farm.cooperativeId),
        (this.farm.cooperativeName = farm.cooperativeName),
        (this.farm.licenceNum = farm.licenceNum),
        (this.farm.licenceExpiryDate = this.formatDate(farm.licenceExpiryDate)),
        (this.farm.regulatorName = farm.regulatorName),
        (this.farm.houseNum = farm.houseNum),
        (this.farm.street = farm.street),
        (this.farm.regulatorRepresentiveName = farm.regulatorRepresentiveName);
      this.farm.coordinates = farm.FarmCoordinates;
      this.farm.communityName = farm.communityName;
      this.farm.farmNumber = farm.farmNumber;
    },
    closeWithoutChange() {
      this.showMap = false;
    },
    resetDefaut() {
      this.tableHeaders = this.reportHeaders;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.reportHeaders.filter(header =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      (this.customizeMenu = false),
        (this.customizeMenuAll = false),
        this.stopLoading();
    },
    downloadPdf(event) {
      let link = document.createElement("a");
      link.download = `${new Date().getTime()}_report.pdf`;
      link.href = event.reportS3Key;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async exportToPDF(doc) {
      html2pdf(this.$refs[doc], {
        margin: [1, 0, 0, 0],
        filename: "Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF(doc) {
      let opt = {
        margin: [1, 0, 0, 0],
        filename: "Report.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(this.$refs[doc])
        .toCanvas()
        .outputPdf("blob", "Report.pdf");
      let file = new File([worker], "Report.pdf", {
        type: "application/pdf",
      });
      console.log(file);
      var pdfUrl = await URL.createObjectURL(file);
      console.log(pdfUrl);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    openPdfDialog(event) {
      //  let encodedUri = encodeURIComponent(event.reportS3Key)
      //  let iFrameUrl = 'https://docs.google.com/gview?url=' + encodedUri;
      this.currentPdfLink = event.reportS3Key;
      this.pdfDialogDialog = true;
    },
    async locationMapClosed(gdata) {
      let tmpObj = {
        farmName: "",
        id: "",
        address: "",
        lat: 27.6669773,
        log: 85.3430367,
        FarmCoordinates: [],
      };
      tmpObj.id = gdata.id;
      tmpObj.address = gdata.address;
      tmpObj.lat = gdata.lat;
      tmpObj.log = gdata.log;

      if (gdata.farmGeofence) {
        gdata.farmGeofence = gdata.farmGeofence.map(coord => {
          coord.lat = `${coord.lat}`;
          coord.log = `${coord.log}`;
          return coord;
        });
      }
      tmpObj.FarmCoordinates = gdata.farmGeofence;

      this.coordinatesModel = JSON.parse(JSON.stringify(tmpObj));
      this.showMap = false;
      console.log(gdata);
      this.showGeofenceNameModal = true;
    },
    showFarm() {
      this.showMap = true;
    },
    showGeofence() {
      this.showMap = true;
      this.newGeofence = true;
    },
    pageChange(t) {
      if (t) {
        this.tableOptions.page = this.tableOptions.page + 1;
        return;
      } else {
        this.tableOptions.page = this.tableOptions.page - 1;
        return;
      }
    },
    todaypageChange(t) {
      if (t) {
        this.todayTableOptions.page = this.todayTableOptions.page + 1;
        return;
      } else {
        this.todayTableOptions.page = this.todayTableOptions.page - 1;
        return;
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/yyyy");
    },
    submitGeofenceName() {
      if (this.$refs.geofenceNameForm.validate()) {
        this.showGeofenceNameModal = false;
        this.coordinatesModel.farmName = this.newGeofenceName;
        this.locationInfoModel = this.newGeofenceName;
        this.optionDialog = false;
      }
      console.log(
        this.$refs.geofenceNameForm.validate(),
        "this.$refs.geofenceNameForm.validate()"
      );
      this.showRequestSatelliteReportDialog = true;
    },
    submitReport() {
      const currentTime = moment.tz(new Date(), moment.tz.guess());
      // console.log(moment.tz.guess())
      // console.log(this.dateOfInterest, 'dateOfInterest')
      // console.log(this.coordinatesModel, 'coordinatesModel')
      // console.log(this.$refs.reportForm.validate())

      if (!this.$refs.reportForm.validate()) return;

      let m = moment.tz(new Date(this.dateOfInterest), moment.tz.guess());

      m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      let formattedDate = m.format("YYYY-MM-DD");

      // console.log(m.format('YYYY-MM-DD HH:mm:ss Z'))

      const data = {
        dateOfInterest: formattedDate,
        createdAt: currentTime.format("YYYY-MM-DD HH:mm:ss Z"),
        locationName: this.coordinatesModel.address
          ? this.coordinatesModel.address
          : this.coordinatesModel.geofenceName,
        userId: 976,
        locationInfo: {
          coordinates:
            this.coordinatesModel.GeoFences &&
            this.coordinatesModel.GeoFences.length > 0
              ? this.coordinatesModel.GeoFences[0].geofenceCoordinates.map(
                  coord => ({ lat: coord.lat, log: coord.log })
                )
              : this.coordinatesModel.geofenceCoordinates.map(coord => ({
                  lat: coord.lat,
                  log: coord.log,
                })),
          type: "Polygon",
        }, // todo
      };

      console.log(data, "datadatadatadata");

      this.startLoading();
      this.$apollo
        .mutate({
          mutation: gql`
            mutation createPastureMgmt($data: CreatePastureMgmtInput!) {
              createPastureMgmt(createPastureMgmtInput: $data)
            }
          `,
          variables: {
            data: data,
          },
        })
        .then(() => {
          this.$notify({
            title: `Report added successfully`,
            text: "success",
            type: "success",
            position: "top right",
          });
          this.showRequestSatelliteReportDialog = false;
          this.existingLocationDialog = false;
          this.confirmationDialog = false;
          this.optionDialog = false;
          this.$apollo.queries.pastureMgmtAllToday.refetch();
          this.$apollo.queries.pastureMgmtAll.refetch();
          this.coordinatesModel = null;
          this.locationInfoModel = null;
        })
        .catch(e => {
          console.log(e);

          this.$notify({
            title: `Report cannot be added.`,
            text: "Something went wrong!",
            type: "error",
            position: "top right",
          });
          this.coordinatesModel = null;
          this.locationInfoModel = null;
        })
        .finally(() => {
          this.stopLoading();
          this.coordinatesModel = null;
          this.locationInfoModel = null;
        });
      this.coordinatesModel = null;
      this.locationInfoModel = null;
    },
    test() {
      this.$apollo.queries.coordinates.refetch();
    },
    selectCoordinates(coordObj) {
      // console.log("test", coordObj)
      if (coordObj.address) {
        //farm location
        this.coordinatesModel = coordObj;
        this.locationInfoModel = coordObj.address;
      } else if (coordObj.geofenceName) {
        //farm zones
        this.coordinatesModel = coordObj;
        this.locationInfoModel = coordObj.geofenceName;
      }
      this.existingLocationDialog = false;
      this.optionDialog = false;
      this.showRequestSatelliteReportDialog = true;
    },
    getProfileData() {
      ProfileService.getProfileData()
        .then(res => {
          if (res.success) {
            this.user.role = res.data.role;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    requestSatelliteReport() {
      this.showRequestSatelliteReportDialog = true;
    },
    openExistingDialog() {
      this.existingLocationDialog = true;
    },
    closeDialog() {
      console.log("dialog close parent");
    },
    showOptionDialog() {
      this.optionDialog = true;
    },
  },
  mixins: [loading],
};
</script>

<style lang="css">
.border {
  border: 2px solid;
  border-color: #dae1ec;
}

.v-tab {
  text-transform: none !important;
}

.input_pointer_cursor .v-input__control .v-input__slot {
  cursor: pointer !important;
}

.v-data-table-header th {
  white-space: nowrap;
}

.v-dialog--active {
  overflow: hidden !important;
}
</style>
